module.exports = __webpack_public_path__ + "static/moliere-9bee8033e5b31a54e8006e1ba6627d0c.jpg";